import script from "./helloAsso.vue?vue&type=script&setup=true&lang=js"
export * from "./helloAsso.vue?vue&type=script&setup=true&lang=js"

import "./helloAsso.vue?vue&type=style&index=0&id=2d0978a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d0978a6"]])

export default __exports__